module.exports = __webpack_public_path__ + "fonts/iconfont.429aaf1b.ttf";